module.exports = __webpack_public_path__ + "img/vip-bar-img.c806962c.png";